<script setup lang="ts">
import type { RouteLocationRaw } from '#vue-router'
import { NuxtLink } from '#components'

defineProps<{ txt: string; to: RouteLocationRaw | undefined }>()

const data = shallowReactive({
  mouted: false,
  init: false,
  style: undefined as undefined | string, // `--f:${7}`,
  on: undefined as undefined | 'on',
})

const animation = useTemplateRef('animation')
let prev: MouseEvent | undefined = undefined
function mouseenter(e: MouseEvent | undefined, mouted?: boolean) {
  if (mouted) data.mouted = true
  if (!data.init) data.init = true
  if (e) prev = e
  const ee = e || prev
  if (ee) animation.value?.mouseenter(ee)
}
</script>

<template>
  <component
    :is="to ? NuxtLink : 'span'"
    :to
    :class="[$style.l, data.on]"
    :style="data.style"
    @mouseenter.passive="(e: MouseEvent) => mouseenter(e)"
    @mouseleave.passive="() => animation?.mouseleave()"
  >
    <slot name="before" />

    <LazyLinkFallingAnimation v-if="data.init" ref="animation" v-model:on="data.on" v-model:style="data.style" :txt @vue:mounted="() => mouseenter(prev, true)" />
    <span v-if="!data.mouted" class="l1">{{ txt }}</span>

    <slot name="after" />
  </component>
</template>

<style module>
.l {
  composes: global(_relative);
  composes: global(_hidden);
  composes: global(_flexline);
  --l1: 0px;
  --l2: 120%;
}

.l::before {
  position: absolute;
  inset: 0px;
  content: '';
  display: block;
  z-index: 0;
  border-radius: 4px;
  background: hsla(240, 5%, 81.6%, 0.3);
  transform: scale(0.01);
  opacity: 0;
  transition:
    transform 300ms var(--tran2),
    opacity 300ms var(--tran2);
}
.l:hover::before {
  transform: scale(1);
  opacity: 1;
}

.l:global(.on):hover {
  --l1: -120%;
  --l2: 0px;
}
/*  */
/*  */
/*  */
/*  */

.l :global(.l1),
.l :global(.l2) {
  padding: 1px;
  display: inline-block;
  white-space: nowrap;
  z-index: 1;
}

.l :global(.l2) {
  inset: 0;
  pointer-events: none;
  user-select: none;
}
.l :global(.l1) span,
.l :global(.l2) span {
  position: relative;
  display: inline-block;
  translate: none;
  rotate: none;
  scale: none;
  transition: transform 150ms var(--tran2);
  /* transition-delay: calc(abs(var(--i) - var(--f, 0)) * 15ms); abs does not work in chrome */
  --i2: calc(var(--i) - var(--f));
  transition-delay: calc(15ms * max(var(--i2), 0 - var(--i2)));
}
.l :global(.l1) span {
  transform: translate(0, var(--l1));
}
.l :global(.l2) span {
  transform: translate(0, var(--l2));
}
.l :global(.l1) :global(.s),
.l :global(.l2) :global(.s) {
  display: inline;
  opacity: 0;
}
</style>
